// extracted by mini-css-extract-plugin
var _1 = "SFZtL";
export { _1 as "configuration" }
